import {useParams} from 'react-router-dom';
import {MigrationRunDetail} from '~/features/Migrations/MigrationRunDetail';

export const MigrationRunDetailScene = () => {
  const {runId} = useParams();

  if (!runId) return <div>No runId</div>;

  return <MigrationRunDetail runId={runId} />;
};
